import { AcronisHttpInstance, IAcronisHttpConfig, IAcronisHttpResponse, acronisHttp } from '@ui/acronis-http';

export interface HttpRequestConfig<T> extends IAcronisHttpConfig<T> {}
export interface HttpResponse<T> extends IAcronisHttpResponse<T> {}

export class HttpService {
  private http: AcronisHttpInstance;

  constructor(tenantUuid?: string) {
    this.http = acronisHttp.getInstance({ tenantUuid });
  }

  public async get<T, R>(path: string, config: HttpRequestConfig<T> = {}): Promise<R> {
    const response: HttpResponse<R> = await this.http.get<T, HttpResponse<R>>(path, config);
    return response.data;
  }

  public put<T, R>(path: string, data: T, config: HttpRequestConfig<T> = {}): Promise<R> {
    return this.http.put<any, R>(path, data, config);
  }

  public post<T, R>(path: string, data: T, config: HttpRequestConfig<T> = {}): Promise<R> {
    return this.http.post<any, R>(path, data, config);
  }

  public patch<T, R>(path: string, data: T, config: HttpRequestConfig<T> = {}): Promise<R> {
    return this.http.patch<any, R>(path, data, config);
  }

  public delete<T, R>(path: string, config: HttpRequestConfig<T> = {}): Promise<R> {
    return this.http.delete<any, R>(path, config);
  }
}

export function createHttpService(tenantUuid?: string): HttpService {
  return new HttpService(tenantUuid);
}
